import React, { useState, useRef } from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import Img from "gatsby-image"
import { device } from "../../utils/breakpoints"
import ModalTrailer from "../ModalTrailer"

const ImageModal = styled(Img)`
  width: 100%;
  height: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  display: block;
  margin: 0 auto;
  cursor: pointer;
  @media ${device.md} {
    margin: inherit;
  }
`

const ModalRetoImage = () => {
  const [openTrailer, setOpenTrailer] = useState(null)
  const handleTrailer = () => {
    setOpenTrailer(true)
  }
  const handleCloseModal = e => {
    if (modalContent.current && !modalContent.current.contains(e.target)) {
      setOpenTrailer(false)
    }
  }
  const closeModal = e => {
    setOpenTrailer(false)
  }

  let modalContent = useRef(null)
  const { image } = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "modal-reto.png" }) {
        sharp: childImageSharp {
          fluid(maxWidth: 1000, quality: 70) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)
  return (
    <>
      <div onClick={handleTrailer}>
        <ImageModal fluid={image.sharp.fluid} />
      </div>
      <ModalTrailer
        modalState={openTrailer}
        closeTrailer={handleCloseModal}
        closeModal={closeModal}
        forwardRef={modalContent}
      />
    </>
  )
}

export default ModalRetoImage
